(ns kyber.lib.pdftron.constants)

(def default-max-zoom-level 2)
(def default-min-zoom-level 0.5)
